import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export default function FaqAccordion({ faqs, testIdPrefix = "faq" }) {
  return (
    <Accordion type="single" collapsible className="w-full">
      {faqs.map((f, idx) => (
        <AccordionItem key={idx} value={`item-${idx}`} className="border-b border-border">
          <AccordionTrigger
            data-testid={`${testIdPrefix}-q-${idx}`}
            className="py-5 text-left font-display text-base font-bold tracking-tight hover:text-petrol hover:no-underline md:text-lg"
          >
            {f.q}
          </AccordionTrigger>
          <AccordionContent
            data-testid={`${testIdPrefix}-a-${idx}`}
            className="pb-6 text-sm leading-relaxed text-muted-foreground"
          >
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
